import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Tab } from './Tab';
import { ActiveTabUnderline, TabsWrapper } from './styles';
const Tabs = ({ tabs, activeTab, handleTabClick, testId = 'tabs-wrapper', className, }) => {
    const activeTabIndex = useMemo(() => tabs.findIndex(({ id }) => id === activeTab), [tabs, activeTab]);
    const handleChange = (id) => {
        if (activeTab !== id) {
            handleTabClick(id);
        }
    };
    return (_jsxs(TabsWrapper, { "data-testid": testId, "data-cy": testId, className: className, children: [tabs.map(({ id, title, titleSize, disabled, img, component, isVisible = true }, index) => {
                const isActive = activeTab === id;
                if (!isVisible) {
                    return null;
                }
                return (_jsx(Tab, { id: id, title: title, disabled: disabled, isActive: isActive, component: component, testId: `tab-${index}`, onClick: handleChange, "data-testid": `tab-${index}`, img: img, titleSize: titleSize }, id?.toString()));
            }), _jsx(ActiveTabUnderline, { length: tabs.length, "data-cy": "tab-underline", className: "tab-highlighter", activeTabIndex: activeTabIndex })] }));
};
export default Tabs;
//# sourceMappingURL=Tabs.js.map